module.exports = __webpack_public_path__ + "static/img/8.b0f7ece.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/8.png
// module id = NM3l
// module chunks = 0